// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"552":"9f366595","638":"37275db7","899":"e072e8a2","985":"f06fa334"}[chunkId] + ".chunk.js";
};